import { ACT_STS_CHANGE } from "../actions/ActionTypes";

const initialState = {
	stats:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_STS_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/StatsReducer.js